import LinearGradient from 'react-native-web-linear-gradient';
export default LinearGradient
